import script from "./SaleDocumentType.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleDocumentType.vue?vue&type=script&setup=true&lang=js"

import "./SaleDocumentType.vue?vue&type=style&index=0&id=94c8650c&lang=css"

const __exports__ = script;

export default __exports__